module.exports = __webpack_public_path__ + "static/img/wdsjtb1-5.868600a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdsjtb1-5.png
// module id = 875
// module chunks = 0